import { z } from 'zod';

import type { IdSalesUnitDto } from '@/services/ws-companies/src/main/resources/rest-api';

export interface EmailDesignFormRouteParams {
  emailDesignId: string | undefined;
}

export enum EmailDesignFormSearchKey {
  SALES_UNIT_ID = 'salesUnitId',
}

export const EmailDesignFormSearchParams = z.object({
  [EmailDesignFormSearchKey.SALES_UNIT_ID]: z.custom<IdSalesUnitDto>().optional(),
});
export type EmailDesignFormSearchParams = z.infer<typeof EmailDesignFormSearchParams>;
